import { Button } from "@components/ui/button";

const calendlyMeetingLink = "https://calendly.com/stackfully/apps";

const openBookingLink = () => {
  window.open(calendlyMeetingLink, "_blank", "noopener,noreferrer");
};

type BookCallButtonProps = {
  text?: string;
  variant?: "outline" | "solid" | "subtle" | "surface" | "ghost" | "plain";
};

const BookCallButton = ({ text = "Book a Call with us", variant = "solid" }: BookCallButtonProps) => {
  return (
    <Button
      colorPalette="blue"
      variant={variant}
      size="lg"
      onClick={openBookingLink}
      mt="4px"
    >
      {text}
    </Button>
  );
};

export default BookCallButton;
